import type { MatchPhase } from "@livcg/schema";

/** Match phases in broadcast order, with their Uzbek operator labels.
 *  Shared by the classic Header and the Control Room clock/phase controls. */
export const PHASES: MatchPhase[] = [
  "pre_match",
  "first_half",
  "halftime",
  "second_half",
  "extra_first",
  "extra_break",
  "extra_second",
  "penalties",
  "full_time",
];

export const PHASE_LABEL: Record<MatchPhase, string> = {
  pre_match: "Match start",
  first_half: "1-taym",
  halftime: "Tanaffus",
  second_half: "2-taym",
  extra_first: "Eq.t. 1-taym",
  extra_break: "Eq.t. tanaffus",
  extra_second: "Eq.t. 2-taym",
  penalties: "Penalti",
  full_time: "Match end",
};

/** Compact label for badges/strips where space is tight. */
export const PHASE_SHORT: Record<MatchPhase, string> = {
  pre_match: "PRE",
  first_half: "1H",
  halftime: "HT",
  second_half: "2H",
  extra_first: "ET1",
  extra_break: "ET·",
  extra_second: "ET2",
  penalties: "PEN",
  full_time: "FT",
};
